import { Link } from "react-router-dom";
import { Smartphone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LANDING } from "@/constants/landingTestIds";

const LOGO_URL = "/logo-icon.png";

const Footer = () => {
  return (
    <footer className="bg-[#020617] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-slate-800">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="Tracre One" className="h-9 w-9 object-contain drop-shadow-sm" />
              <span className="font-heading text-lg font-bold text-white">Tracre One</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              AI Powered Real Estate CRM for agents, brokers & consultants who want to grow
              their business 10x — right from their pocket.
            </p>
            <Button
              data-testid={LANDING.footerDownloadBtn}
              onClick={() => window.open("#", "_blank", "noopener,noreferrer")}
              className="mt-6 bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-lg h-11 font-semibold gap-2 transition-all duration-300"
            >
              <Smartphone className="w-4 h-4" />
              Download Android App
            </Button>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-wide uppercase">
              Legal & Compliance
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/privacy-policy"
                  data-testid={LANDING.footerPrivacyLink}
                  className="text-slate-400 hover:text-[#38bdf8] transition-colors text-left"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-conditions"
                  data-testid={LANDING.footerTermsLink}
                  className="text-slate-400 hover:text-[#38bdf8] transition-colors text-left"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/data-deletion"
                  data-testid={LANDING.footerDataDeletionLink}
                  className="text-slate-400 hover:text-[#38bdf8] transition-colors text-left"
                >
                  Data Deletion
                </Link>
              </li>
              <li>
                <a
                  data-testid={LANDING.footerContactLink}
                  href="mailto:support@tracreoneai.com"
                  className="text-slate-400 hover:text-[#38bdf8] transition-colors text-left"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-wide uppercase">
              Support
            </h4>
            <p className="text-slate-400 text-sm mb-3">
              Have questions or need to request data removal?
            </p>
            <a
              data-testid={LANDING.footerEmailLink}
              href="mailto:support@tracreoneai.com"
              className="inline-flex items-center gap-2 text-[#38bdf8] hover:text-[#7dd3fc] font-medium text-sm transition-colors"
            >
              <Mail className="w-4 h-4" /> support@tracreoneai.com
            </a>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} Tracre One. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            Built for real estate agents, brokers & property consultants.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
